import React from 'react'
import { Route } from 'react-router'
import Loader from '../base/components/loader/loader'
import lang from '@/lang'
import staffService from '@/modules/_services/staffService'

const staffRoutes = (
  <>
    <Route path='/staff' Component={() => {
      staffService.openStaffPage()
      return <Loader text={lang.staff.loading} />
    }} />
  </>
)

export default staffRoutes
